import React, { PureComponent } from 'react';
import { Bar } from 'react-chartjs-2';
import find from 'lodash/find';
import get from 'lodash/get';
import moment from 'moment';

import {
  getWarrantyStatstics,
  getBreakdownStatistics,
  getClientStatistics,
  getVoivodeshipStatistic,
} from '../services/dashboard.service';
import {
  BREAKDOWN_STATUSES,
  DATE_MONTH_FORMAT,
  MOMENT_MONTH_FORMAT,
} from '../../app/config/config';
import { Datepicker } from '../../common/components';
import DashboardCard from './dashboardCard.component';

class Dashboard extends PureComponent {
  state = {
    isLoading: false,
    warranty: {},
    breakdown: {},
    client: {},
    voivodeship: {
      date: '',
    },
  }

  componentDidMount() {
    this.getWarrantyStatistic();
    this.getBreakdownStatistic();
    this.getClientStatistics();
    this.getVoivodeshipStatistic(moment());
  }

  getWarrantyStatistic = async () => {
    try {
      const result = await getWarrantyStatstics();
      const currentMonthDate = moment().format(MOMENT_MONTH_FORMAT);
      const prevMonthDate = moment().subtract(1, 'month').format(MOMENT_MONTH_FORMAT);
      const prevMonth = find(result, { month: prevMonthDate });
      const currentMonth = find(result, { month: currentMonthDate });

      this.setState({
        warranty: {
          ...this.state.warranty,
          prevMonth,
          currentMonth,
        },
      });
    } catch (error) {
      console.error(error);
    }
  }

  getBreakdownStatistic = async () => {
    try {
      const { prevMonth, currentMonth } = await getBreakdownStatistics();

      this.setState({
        breakdown: {
          ...this.state.breakdown,
          prevMonth,
          currentMonth,
        },
      });
    } catch (error) {
      console.error(error);
    }
  }

  getClientStatistics = async () => {
    try {
      const { totalClients } = await getClientStatistics();

      this.setState({
        client: {
          totalClients,
        },
      });
    } catch (error) {
      console.error(error);
    }
  }

  getVoivodeshipStatistic = async (date) => {
    const newDate = moment(date).format('DD-MM-YYYY');

    try {
      const data = await getVoivodeshipStatistic(newDate);

      this.setState({
        voivodeship: {
          ...this.state.voivodeship,
          data,
        },
      });
    } catch (error) {
      console.error(error);
    }
  }

  renderChart = () => {
    const { voivodeship: { data = [], date } } = this.state;
    const chartColor = '#42a5f5';
    const chartColorBreakdown = '#dc143c';

    return (
      <>
        <Datepicker
          selected={date || new Date()}
          id="voivodeship"
          label="Wybierz miesiąc"
          maxDate={new Date()}
          dateFormat={DATE_MONTH_FORMAT}
          showMonthYearPicker
          onChange={this.onDateSelect}
        />
        <Bar
          height={80}
          options={{
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  stepSize: 1,
                },
              }],
            },
          }}
          data={{
            labels: data.map(({ name }) => name),
            datasets: [{
              label: 'Ilość gwarancji',
              backgroundColor: chartColor,
              data: [...data.map(({ count }) => count)],
            },
            {
              label: 'Ilość awarii',
              backgroundColor: chartColorBreakdown,
              data: [...data.map(({ breakdown_count }) => breakdown_count), 0],
            }],
          }}
        />
        <Bar
          height={80}
          options={{
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                },
              }],
            },
          }}
          data={{
            labels: data.map(({ name }) => name),
            datasets: [{
              label: 'Wartość gwarancji w PLN',
              backgroundColor: chartColor,
              data: [...data.map(({ warranty_sum_price }) => warranty_sum_price), 0],
            },
            {
              label: 'Wartość napraw w PLN',
              backgroundColor: chartColorBreakdown,
              data: [...data.map(({ breakdown_sum_price }) => breakdown_sum_price), 0],
            }],
          }}
        />
      </>
    );
  }

  renderPrevMonthBreakdownStatuses = () => {
    const {
      breakdown: {
        prevMonth: breakdownPrevMonth,
      },
    } = this.state;

    return this.renderBreakdownStatus(breakdownPrevMonth, 'prev');
  }

  renderCurrentMonthBreakdownStatuses = () => {
    const {
      breakdown: {
        currentMonth: breakdownCurrentMonth,
      },
    } = this.state;

    return this.renderBreakdownStatus(breakdownCurrentMonth);
  }

  renderBreakdownStatus = (data, templateType) => Object.keys(BREAKDOWN_STATUSES).map((status, index) => {
    const value = get(find(data.breakdown_statuses, (obj) => obj.status === +status), 'count', 0);

    return this.renderStatisticTemplate(index, value, status, templateType);
  })

  renderStatisticTemplate = (index, value, key, templateType = 'current') => (
    <DashboardCard title={`Awarie w statusie "${BREAKDOWN_STATUSES[key]}" w ${templateType === 'current' ? 'tym ' : 'ostatnim'} miesiącu`} value={`${value}`} key={index} icon="pe-7s-graph1" />
  )

  onDateSelect = (key, value) => {
    this.setState({
      [key]: {
        ...this.state[key],
        date: value,
      },
    }, () => this.getVoivodeshipStatistic(value));
  }

  render() {
    const {
      warranty: {
        prevMonth: warrantyPrevMonth,
        currentMonth: warrantyCurrnetMonth,
      },
      breakdown: {
        prevMonth: breakdownPrevMonth,
        currentMonth: breakdownCurrentMonth,
      },
      client: {
        totalClients,
      },
      voivodeship,
    } = this.state;

    return (
      <div className="content">
        <div className="animated fadeIn">
          <div className="row mt-4">
            <DashboardCard title="Ilość sprzedanych gwarancji w ostatnim miesiącu" value={`${get(warrantyPrevMonth, 'total', 0)}`} icon="pe-7s-cart" />
            <DashboardCard title="Wartość sprzedanych gwarancji w ostatnim miesiącu" value={`${get(warrantyPrevMonth, 'warranty_price_sum', 0)} zł`} icon="pe-7s-cash" />
            <DashboardCard title="Ilość sprzedanych gwarancji w tym miesiącu" value={`${get(warrantyCurrnetMonth, 'total', 0)}`} icon="pe-7s-cart" />
            <DashboardCard title="Wartość sprzedanych gwarancji w tym miesiącu" value={`${get(warrantyCurrnetMonth, 'warranty_price_sum', 0)} zł`} icon="pe-7s-cash" />
            <DashboardCard title="Ilość klientów" value={`${totalClients || 0}`} icon="pe-7s-users" />
          </div>
          <div className="row mt-4">
            <DashboardCard title="Ilość awarii w ostatnim miesiącu" value={`${get(breakdownPrevMonth, 'breakdowns', 0)}`} icon="pe-7s-tools" />
            {breakdownPrevMonth && this.renderPrevMonthBreakdownStatuses()}
          </div>
          <div className="row mt-4">
            <DashboardCard title="Ilość awarii w tym miesiącu" value={`${get(breakdownCurrentMonth, 'breakdowns', 0)}`} icon="pe-7s-tools" />
            {breakdownCurrentMonth && this.renderCurrentMonthBreakdownStatuses()}
          </div>
          <div className="row mt-4">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  {voivodeship && this.renderChart()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;
